export default __webpack_public_path__ + "static/media/trafalgar.f2ef8e1f.jpg";